// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1RYBs","row":"ProcedureTreatmentSummary_row__JVrsO"};